export enum ExportAs {
    WORD = "WORD",
    GOOGLE_DOCS = "GOOGLE_DOCS"
}